import { Component, OnInit, ViewChild } from "@angular/core";
import { GetSchedulingExtractsUsecase } from "@src/core/usecases/extract/get-scheduling-extracts.usecase";
import { GetReceiptPdfUsecase } from "@src/core/usecases/receipt/get-receipt-pdf-usecases";
import { DetailsTransacionEnum } from "@src/shared/enum/bfd-popover.enum";
import { PopoverService } from "@src/shared/services/popover.service";
import * as moment from "moment";
import { ToastErrorMessageComponent } from "../toast-error-message/toast-error-message.component";
@Component({
  selector: "bfd-extract-scheduling",
  templateUrl: "./bfd-extract-scheduling.component.html",
  styleUrls: ["./bfd-extract-scheduling.component.scss"],
})
export class ExtractSchedlulingComponent implements OnInit {
  @ViewChild(ToastErrorMessageComponent, { static: false }) toast: ToastErrorMessageComponent;
  public pagina = "0";
  public qtfRegister = "30";
  public loadingScroll = false;
  public loadingController = false;
  public loading = false;
  public showError = false;
  public toDay = moment().format("YYYY-MM-DD");
  public typeView!: string;
  public balanceSingle = [];
  public typToastColor;
  public REDCOLOR = '#ED6C6C';
  public GREENCOLOR = '#73B599';

  public payload = {
    dataInicio: this.toDay,
    dataFinal: this.getDateNDaysLate(7),
    numeroPagina: this.pagina,
    quantidadeRegistrosPagina: this.qtfRegister,
  };
  public contentEmptyData = {
    icon: "bfd-pict-alert",
    title: "Não há movimentações",
    description: "Tente efetuar uma nova pesquisa informando um outro período",
  };

  scheduleObj = [];

  constructor(
    private getSchedulingExtractsUsecase: GetSchedulingExtractsUsecase,
    public popoverService: PopoverService,
    private getReceiptPdfUsecase: GetReceiptPdfUsecase
  ) {}

  ngOnInit(): void {
    this.getSchedule(this.payload);
  }

  public getSchedule(obj) {
    this.showError = false;
    this.loading = true
    this.getSchedulingExtractsUsecase
      .execute(obj)
      .subscribe(this.successSchedule, this.errorSchedule);
  }

  private successSchedule = (value) => {
    this.loading = false;
    this.scheduleObj = value.data;
  };

  private errorSchedule = (error) => {
    this.loading = false;
    this.showError = true;
  };

  public handleRange(range: { start: Date; end: Date }): void {
    this.payload.dataInicio = moment(range.start).format("YYYY-MM-DD");
    this.payload.dataFinal = moment(range.end).format("YYYY-MM-DD");
    this.getSchedule(this.payload);
  }

  getDateNDaysLate(days: number): string {
    const d = new Date();
    d.setDate(d.getDate() + days + 1);
    return moment(d).format("YYYY-MM-DD");
  }

  public tryRequest(event?): void {
    this.showError = false;
   this.getSchedule(this.payload);
  }

  public getInfBalance(event): void {
    this.balanceSingle = event;
    this.typeView = DetailsTransacionEnum.TypeView;
    this.showPopover();
  }

  public showPopover(): void {
    this.popoverService.setAllowLoad(true);
    this.popoverService.openModal();
  }

  public downloadReceipt(event): void {
   if(event !== 0) {
    this.getReceiptPdfUsecase.execute(event).subscribe(
      this.successdownload, this.errorPdf
    );
   }
  }

  private successdownload = (value) => {
    fetch(value.data.url)
    .then((resp) => resp.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = "ComprovantePagamento.pdf";
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    })
    this.typToastColor = this.GREENCOLOR;
    this.toast.callModalMessage(null, 'Arquivo baixado com sucesso.');
  };

  private errorPdf = (err) => {
    this.typToastColor = this.REDCOLOR;
    this.toast.callModalMessage(null, "Falha no download do comprovante tente novamente");
  };
}
